import { Row, Col } from 'reactstrap';
import { FormState } from 'common/entities/form/FormTypes';
import Company from './Company';

const VisibilitySettings = ({ text, organizationsState }) => {
  return (
    <>
      {text ? (
        <Row noGutters>
          <Col className="fs-12 fw-medium text-violet">{text}</Col>
        </Row>
      ) : null}
      <div className="d-flex flex-column mt-1">
        {(organizationsState || [])?.map((formState, index) => (
          <Company key={index} formState={formState} />
        ))}
      </div>
    </>
  );
};

VisibilitySettings.propTypes = {
  organizationsState: FormState.isRequired
};

export default VisibilitySettings;
